import React, { createContext, useContext } from 'react';

import { useBuildingWrapper } from 'src/modules/designStudio/providers/BuildingWrapperProvider/useBuildingWrapper';
import { createBuildingAppearances } from 'src/modules/designStudio/providers/MacheteBuildingProvider/helpers';
import type {
  BuildingAppearances,
  MutateBuildingFunction,
} from 'src/modules/designStudio/providers/MacheteBuildingProvider/types';

import { context as MacheteBuildingProvider } from '../MacheteBuildingProvider';

type ContextValue = {
  buildingAppearances: BuildingAppearances;
  mutateBuilding: (update: MutateBuildingFunction) => void;
};

export const defaultContextValue: ContextValue = {
  buildingAppearances: createBuildingAppearances(undefined),
  mutateBuilding: () => {},
};

const context = createContext<ContextValue>(defaultContextValue);

const Provider = ({ children }: { children: React.ReactNode }) => {
  const { building } = useContext(MacheteBuildingProvider);

  const { buildingAppearances, mutateBuilding } = useBuildingWrapper({
    building,
  });

  return (
    <context.Provider value={{ buildingAppearances, mutateBuilding }}>
      {children}
    </context.Provider>
  );
};

export { Provider, context };
